import dotProp from 'dot-prop-immutable';

import * as actionTypes from './actiontypes';
import states from './states';


export default function entity_details(state = states.entity_details, action) {
    switch (action.type) {
        case actionTypes.UPDATE_ENTITY_STATE: {
            return dotProp.set(state, action.path, action.payload);
        }

        case actionTypes.DELETE_ENTITY_STATE: {
            return dotProp.delete(state, action.path);
        }

        case actionTypes.ALL_ENTITIES_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    entities_loading: true,
                    entities_loaded: false,
                }
            };
        }

        case actionTypes.ALL_ENTITIES_LOADED: {
            return {
                ...state,
                entities: action.payload && action.payload.entities ? action.payload.entities : [...state.entities],
                loaders: {
                    ...state.loaders,
                    entities_loading: false,
                    entities_loaded: true,
                }
            };
        }

        case actionTypes.ALL_ENTITIES_LOAD_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    entities_loading: false,
                    entities_loaded: false,
                }
            };
        }

        case actionTypes.ENTITY_DELETED: {
            let index = -1;
            if (action.payload && action.payload.data && action.payload.data.entityID) {
                index = state.entities.findIndex((entity) => { return (entity.entityID === action.payload.data.entityID) });
            }
            return {
                ...state,
                entities: index === -1 ? [...state.entities] : [...state.entities.slice(0, index), ...state.entities.slice(index + 1)],
            };
        }

        case actionTypes.ENTITY_CREATING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    entity_creating: true,
                }
            };
        }

        case actionTypes.ENTITY_CREATED: {
            if (action.payload.data && action.payload.data.children)
                delete action.payload.data.children;
            return {
                ...state,
                entities: action.payload.data ? [action.payload.data, ...state.entities] : [...state.entities],
                loaders: {
                    ...state.loaders,
                    entity_creating: false,
                }
            };
        }

        case actionTypes.ENTITY_CREATION_FAILED: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    entity_creating: false,
                }
            };
        }

        case actionTypes.ENTITY_DATA_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    entity_data_loading: true,
                    entity_data_loaded: false,
                }
            };
        }

        case actionTypes.ENTITY_DATA_LOADED: {
            return {
                ...state,
                active_entity_data: action.payload.data,
                loaders: {
                    ...state.loaders,
                    entity_data_loading: false,
                    entity_data_loaded: true,
                }
            };
        }

        case actionTypes.ENTITY_DATA_LOAD_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    entity_data_loading: false,
                    entity_data_loaded: false,
                }
            };
        }

        case actionTypes.ENTITY_UPDATING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    entity_updating: true,
                }
            };
        }

        case actionTypes.ENTITY_UPDATED: {
            let index = -1;
            if (action.payload.data && action.payload.data.entity && action.payload.data.entity.entityID) {
                index = state.entities.findIndex((entity) => { return (entity.entityID === action.payload.data.entity.entityID); });
                if (action.payload.data.entity.children)
                    delete action.payload.data.entity.children;
            }

            return {
                ...state,
                entities: index !== -1 ? [...state.entities.slice(0, index), action.payload.data.entity, ...state.entities.slice(index + 1)] : [...state.entities],
                loaders: {
                    ...state.loaders,
                    entity_updating: false,
                }
            };
        }

        case actionTypes.ENTITY_UPDATION_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    entity_updating: false,
                }
            };
        }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/data/redux/entity_details/reducers.js